module.exports = __webpack_public_path__ + "static/BrandonGrotesque-ThinItalic-c2b141ce7d4baf6671cc157a294ba22e.woff";